<template>
  <div class="mt-1 relative">
    <div class="relative">
      <input
        type="text"
        class="relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        :class="[{'bg-white':!disabled,'bg-gray-100':disabled},{'cursor-pointer':!disabled,'cursor-not-allowed':disabled}]"
        aria-haspopup="listbox"
        aria-expanded="true"
        aria-labelledby="listbox-label"
        v-model="search"
        @click="showDropdown = true"
        :placeholder="placeholder"
        @focus="$event.target.select()"
        :disabled="disabled"
      />
      <span class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <!-- Heroicon name: solid/selector -->
        <svg
          class="h-5 w-5 text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
      <input type="hidden" :value="modelValue" />
    </div>

    <div v-show="showDropdown" class="fixed inset-0 z-40" @click="showDropdown = false"></div>
    <!--
        Select popover, show/hide based on select state.

        Entering: ""
            From: ""
            To: ""
        Leaving: "transition ease-in duration-100"
            From: "opacity-100"
            To: "opacity-0"
    -->
    <ul
      leave-from-class="transition ease-in duration-100 opacity-100"
      leave-to-class="transition ease-in duration-100 opacity-0"
      class="absolute mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm z-50"
      tabindex="-1"
      role="listbox"
      aria-labelledby="listbox-label"
      aria-activedescendant="listbox-option-3"
      v-if="showDropdown && options.length"
    >
      <!--
            Select option, manage highlight styles based on mouseenter/mouseleave and keyboard navigation.

            Highlighted: "text-white bg-indigo-600", Not Highlighted: "text-gray-900"
      -->
      <li
        class="text-gray-900 hover:bg-indigo-600 hover:text-white cursor-default select-none relative py-2 pl-3 pr-9"
        id="listbox-option-0"
        role="option"
        v-for="option,index in filteredList"
        :key="index"
        @click="updateList(option)"
      >
        <div class="flex items-center">
          <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
          <span class="font-normal ml-3 block truncate">{{option.title}}</span>
        </div>

        <!--
                Checkmark, only display for selected option.

                Highlighted: "text-white", Not Highlighted: "text-indigo-600"
        -->
        <span
          class="text-indigo-600 absolute inset-y-0 right-0 flex items-center pr-4"
          v-if="selected && selected.id == option.id"
        >
          <!-- Heroicon name: solid/check -->
          <svg
            class="h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </span>
      </li>
      <li
        class="text-gray-900 hover:bg-indigo-600 hover:text-white cursor-default select-none relative py-2 pl-3 pr-9"
        id="listbox-option-0"
        role="option"
        v-if="!filteredList.length"
      >
        <div class="flex items-center">
          <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
          <span class="font-normal ml-3 block truncate text-gray-500">not found</span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ["options", "placeholder", "modelValue", "disabled"],
  emits: ["update:modelValue", "change"],
  data() {
    return {
      selected: this.modelValue,
      showDropdown: false,
      search: ""
    };
  },
  methods: {
    updateList(option) {
      this.selected = option;
      this.search = option.title;
      this.showDropdown = false;
      this.$emit("update:modelValue", this.selected);
      this.$emit("change");
    }
  },
  computed: {
    filteredList() {
      return this.options.filter(option => {
        return option.title.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  mounted() {
    var selected = this.modelValue
      ? this.options.find(option => {
          return this.modelValue.id
            ? option.id == this.modelValue.id
            : option.title == this.modelValue;
        })
      : "";
    this.search = selected ? selected.title : "";
  },
  watch: {
    modelValue(v) {
      this.selected = v;
      var selected = v
        ? this.options.find(option => {
            return v.id ? option.id == v.id : option.title == v;
          })
        : "";
      this.search = selected ? selected.title : "";
    },
    search(n,o){
      if(!n){
         this.$emit("update:modelValue", []);
      }
    }
  }
};
</script>
<style>
li:hover span {
  color: #fff;
}
</style>
